<template>
  <div>
    <b-card class="custom-card">
      <div class="d-flex align-items-center w-100">
        <h5 class="">Документы</h5>
        <b-button class="custom-btn-primary ml-auto" @click="onAdd" :disabled="isDisabled">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить
        </b-button>
      </div>

      <div class="page-body">
        <template v-if="isBusy || (items && items.length > 0)">
          <div class="page-table-container">
            <b-table
              id="task-files"
              ref="task_files"
              class="custom-table mb-0"
              selectable
              select-mode="single"
              responsive
              :busy="isBusy"
              :items="items"
              :fields="fields"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(path)="row">
                <b-link style="color: #1A9167 !important;" @click="onDownload(row.item.id, row.item.path)">{{row.item.path}}</b-link>
              </template>

              <template #cell(action)="row">
                <b-button variant="link" @click="onRemove(row)" :disabled="isDisabled">
                  <v-icon name="buttons/trash" :size="16"/>
                </b-button>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="items.length"
              :per-page="perPage"
              :current-page.sync="currentPage"
              @per-page-change="onPerPageChange"
            >
              <template #footer-list>
                Всего файлов: <b>{{items.length}}</b>
              </template>
            </pagination-footer>
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>Нет добавленных файлов</h5>
        </div>
      </div>
    </b-card>

    <b-modal
      id="modal-file"
      ref="modal_file"
      title="Загрузка файла"
      modal-class="custom-modal"
      @show="onResetModal"
      @hidden="onResetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-file
          id="input_number"
          size="sm"
          placeholder="Файлы не выбраны"
          browse-text="Выбрать"
          autocomplete="off"
          v-model="newFile"
        />
      </form>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" @click="handleOk">
            Добавить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import tasks from "../../network/tasks";
  import helpers from "../../utilites/helpers";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "TaskFiles",
  components: { PaginationFooter },
  mixins: [
    tasks,
    helpers
  ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      task_id: 0,
      newFile: null,
      items: [],
      fields: [
        {
          key: 'path',
          label: 'Файл',
          class: 'text-center'
        },
        {
          key: 'action',
          label: 'Действие',
          class: 'text-center'
        },
      ],
      perPage: 10,
      currentPage: 1,
      isBusy: false,
      deleteRow: {
        id: null,
        path: ''
      },
    }
  },
  methods: {
    configure(taskId) {
      this.task_id = taskId;
      this.getItems();
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getTaskFilesByTaskId(this.task_id);
      this.isBusy = false;

      this.items = result.data;
    },
    onAdd() {
      if (this.task_id === 0) {
        const message = `Сначала создайте заявку. Нажмите кнопку "Сохранить"`
        this.$bvToast.toast(message, {
          title: 'Ошибка добавления файла',
          variant: 'danger',
          autoHideDelay: 3000,
          solid: true
        });
        return;
      }

      this.$bvModal.show('modal-file');
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление файла";
      const message = `Вы действительно хотите удалить файл ${this.deleteRow.path}?`;
      this.showModalDelete(title, message, function () {
        this.removeItem(this.deleteRow);
      }.bind(this));
    },
    onResetModal() {
      this.newFile = null;
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    handleCancel() {
      this.$refs.modal_file.hide();
    },
    async handleSubmit() {
      if (!this.newFile) return;

      let formData = new FormData();
      formData.append("file", this.newFile, this.newFile.name);

      const result = await this.postTaskFile(this.task_id, formData);

      if (result.error !=null) {
        console.log(result.error);
        return;
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-file');
      })

      await this.getItems();
    },
    async onDownload(id, fileName) {
      const result = await this.getTaskFile(id);

      if (!result.data) return;

      this.handleFileDownload(result.data, fileName);
    },
    async removeItem(item) {
      const result = await this.deleteTaskFile(item.id);
      if (result.data == null) {
        return;
      }
      await this.getItems();
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style>
#task-files td {
  text-align: left;
  vertical-align: middle;
}

#task-files th {
  text-align: left;
  vertical-align: middle;
}

#task-files-pagination {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tasks/TaskFiles.vue